import { ApolloError, useQuery } from '@apollo/client'
import { OBJECTIVE_DTO_LIST_AND_EMPLOYEE_CONTRACT } from './ObjectiveQuery'
import { ObjectiveListAndEmployeeContractQuery, ObjectiveListAndEmployeeContractQueryVariables } from '../../types'

export const useObjectiveDTOListAndEmployeeContract = (
  employeeId: number,
  resignedView = false,
): {
  data: ObjectiveListAndEmployeeContractQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<ObjectiveListAndEmployeeContractQuery, ObjectiveListAndEmployeeContractQueryVariables>(
    OBJECTIVE_DTO_LIST_AND_EMPLOYEE_CONTRACT,
    {
      variables: {
        employeeId: employeeId,
        employeeResigned: resignedView,
      },
      errorPolicy: 'all',
      fetchPolicy: 'network-only',
      returnPartialData: true,
    },
  )

  return { data, error, loading }
}
